import { createSlice } from '@reduxjs/toolkit';

export interface FilesState {
  value: any;
}

const initialState: FilesState = {
  value: '',
};

export const ReportTypeSlice = createSlice({
  name: 'reportType',
  initialState,
  reducers: {
    setReportTypeVal: (state, action) => {
      // Redux Toolkit allows us to write "mutating" logic in reducers. It
      // doesn't actually mutate the state because it uses the Immer library,
      // which detects changes to a "draft state" and produces a brand new
      // immutable state based off those changes
      state.value = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setReportTypeVal } = ReportTypeSlice.actions;

export default ReportTypeSlice.reducer;
